export const corporate_name = 'Plafon PVC'